import * as React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { useQuery } from 'react-query';
import { bvdApiClient } from 'utils/bvdApiClient';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';

interface ProgressBarProps {
  value: any;
}

const CONDITION_UUID_VERY_GOOD = '0125fa46-d343-499f-91f0-bed3f336eb22';

const ProgressBar = ({
  value: { externalId, valueToCompareTo },
}: ProgressBarProps) => {
  const { locale } = useRouter();

  const { isLoading: isLoadingProduct, data: productData } = useQuery(
    ['product', externalId, CONDITION_UUID_VERY_GOOD],
    () =>
      bvdApiClient(locale).userSells.products.getByExternalIdWithConditionLevel(
        externalId,
        CONDITION_UUID_VERY_GOOD
      ),
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );

  const MINUTES_OF_HOUR = 60;
  const { isLoading: isLoadingOffers, data: offers } = useQuery(
    ['offer', CONDITION_UUID_VERY_GOOD, productData?.payload?.uuid],
    () =>
      bvdApiClient(locale).userSells.offers.getOffersForProduct(
        productData.payload.uuid,
        null,
        6 * MINUTES_OF_HOUR
      ),
    {
      enabled: !!productData,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    }
  );

  const bestOffer = offers?.payload
    .filter((item: any) => item.price > 0)
    .sort((a: any, b: any) => b.price - a.price)[0];

  const valueInPercent = bestOffer
    ? (bestOffer.price / valueToCompareTo) * 100
    : 0;
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: 26,
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          lineHeight: '24px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >{`${valueInPercent.toFixed(0).toLocaleString()} %`}</Box>
      <Box
        sx={{ height: '100%', backgroundColor: '#088208a3' }}
        style={{ maxWidth: `${valueInPercent}%` }}
      />
    </Box>
  );
};

export function renderProgress(params: GridRenderCellParams<number, any, any>) {
  if (params.rowNode.isAutoGenerated || params.value == null) {
    return '';
  }

  return <ProgressBar value={params.value} />;
}
